import { CalculadoraCredito } from "../../../bpm/CustomFormNew/CustomForms/CreditoyCartera/Components/CalculadoraCredito"
import { BasicPage } from "../../../theme/Component/BasicPage"

export const DeudorCapacity =()=>{

    return(
        <BasicPage titulo="Capacidad de Endeudamiento" >
            <CalculadoraCredito props={{}}  />
        </BasicPage>
    )
}